// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/articleManage',
    name: 'ArticleManage',
    component: layout,
    redirect: '/articleManage/index',
    meta: {
      title: '文章管理',
      i18Key: 'router.user.articleManage.title',
      roles: [1],
      category: 'setting'
    },
    sort: 20,
    children: [
      {
        path: 'index',
        name: 'ArticleManageIndex',
        component: () => import('@/views/ArticleManage/Index.vue'),
        meta: {
          title: '文章管理',
          i18Key: 'router.user.articleManage.index',
          roles: [1]
        }
      }
    ]
  }
]
export default routes
